import { render, staticRenderFns } from "./CreateStockin.vue?vue&type=template&id=3598a550&scoped=true"
import script from "./CreateStockin.vue?vue&type=script&lang=js"
export * from "./CreateStockin.vue?vue&type=script&lang=js"
import style0 from "./CreateStockin.vue?vue&type=style&index=0&id=3598a550&prod&scoped=true&lang=css"
import style1 from "./CreateStockin.vue?vue&type=style&index=1&id=3598a550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3598a550",
  null
  
)

export default component.exports